import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Select from "react-select";
import {
  getAllResellerWallet,
  getResellerWalletById,
} from "../../../config/LiveApi";
import { toast } from "react-toastify";
import Spinner from "../../Spin/Spinner";

/* ---------------- Styles ---------------- */

const pageWrapper = {
  padding: "40px",
  backgroundColor: "#f9fafb",
  minHeight: "100vh",
};

const card = {
  backgroundColor: "#ffffff",
  padding: "30px",
  borderRadius: "16px",
  boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
};

const heading = {
  fontSize: "22px",
  fontWeight: "600",
  marginBottom: "25px",
  color: "#111827",
};

const filterWrapper = {
  width: "300px",
  marginBottom: "20px",
};

const table = {
  width: "100%",
  borderCollapse: "collapse",
};

const th = {
  textAlign: "left",
  padding: "12px",
  backgroundColor: "#00C389",
  color: "#fff",
  // backgroundColor: "#f3f4f6",
  fontSize: "14px",
  fontWeight: "600",
  borderBottom: "1px solid #e5e7eb",
};

const td = {
  padding: "12px",
  fontSize: "14px",
  borderBottom: "1px solid #e5e7eb",
  color: "#374151",
};

const statusMessage = {
  marginTop: "20px",
  fontSize: "14px",
};

/* ---------------- Component ---------------- */

const GetAllResellerWallet = () => {
  const token = useSelector((store) => store.userReducer.token);
  const resellerId = useSelector((store) => store.userReducer.userId);
  const role = useSelector((store) => store.userReducer.role);

  const [wallets, setWallets] = useState([]);
  const [resellerOptions, setResellerOptions] = useState([]);
  const [selectedReseller, setSelectedReseller] = useState(null);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  /* -------- Fetch ALL Wallets (For Admin Roles) -------- */

  const fetchAllWallets = async () => {
    try {
      setLoading(true);

      const response = await getAllResellerWallet(token);

      if (response.status) {
        setWallets(response.data);

        const uniqueResellers = [
          ...new Map(
            response.data.map((item) => [
              item.resellerId,
              {
                value: item.resellerId,
                label: item.name,
              },
            ]),
          ).values(),
        ];

        setResellerOptions(uniqueResellers);
      }
    } catch (error) {
      toast.error("Failed to fetch wallets.");
    } finally {
      setLoading(false);
    }
  };

  /* -------- Fetch ONLY Logged-In Reseller Wallet -------- */

  const fetchResellerWallet = async (idFromDropdown) => {
    try {
      setLoading(true);

      let idToSend;

      if (role === "reseller") {
        idToSend = resellerId;
      } else {
        idToSend = idFromDropdown;
      }

      // console.log("Sending ID:", idToSend);

      if (!idToSend) return;

      const response = await getResellerWalletById(idToSend, token);

      if (response.status) {
        setWallets(response.data);
      } else {
        setWallets([]);
        toast.error("No wallet found ❌");
      }
    } catch (error) {
      toast.error("Failed to fetch wallet ❌");
    } finally {
      setLoading(false);
    }
  };

  const handleFilterChange = (selected) => {
    setSelectedReseller(selected);

    if (!selected) {
      fetchAllWallets();
      return;
    }

    fetchResellerWallet(selected.value);
  };

  /* -------- Role-Based Initial Load -------- */

  useEffect(() => {
    if (!token) return;

    if (role === "reseller") {
      fetchResellerWallet();
    } else {
      fetchAllWallets();
    }
  }, [token, role]);

  return (
    <div style={pageWrapper}>
      <div style={card}>
        <h2 style={heading}>
          {role === "reseller" ? "Wallet Transactions" : "All Reseller Wallets"}
        </h2>

        {role !== "reseller" && (
          <div style={filterWrapper}>
            <Select
              options={resellerOptions}
              value={selectedReseller}
              onChange={handleFilterChange}
              placeholder="Filter by Reseller ID"
              isClearable
            />
          </div>
        )}

        {loading ? (
          <div>
            <Spinner />
          </div>
        ) : wallets.length === 0 ? (
          <div style={{ ...statusMessage, color: "#dc2626" }}>
            {"No wallets available"}
          </div>
        ) : (
          <table style={table}>
            <thead>
              <tr>
                {role != "reseller" && <th style={th}>Name</th>}
                {/* <th style={th}>Reseller ID</th> */}
                <th style={th}>Period Start</th>
                <th style={th}>Period End</th>
                <th style={th}>Amount</th>
                <th style={th}>Remarks</th>
                <th style={th}>Created At</th>
              </tr>
            </thead>
            <tbody>
              {wallets.map((item) => (
                <tr key={item.id}>
                  {role != "reseller" && <td style={td}>{item.name}</td>}
                  {/* <td style={td}>{item.resellerId}</td> */}
                  <td style={td}>
                    {new Date(item.periodStart).toLocaleDateString()}
                  </td>
                  <td style={td}>
                    {new Date(item.periodEnd).toLocaleDateString()}
                  </td>
                  <td style={{ ...td, fontWeight: "600", color: "#2563eb" }}>
                    ₹ {item.amount}
                  </td>
                  <td style={td}>{item.remarks || "-"}</td>
                  <td style={td}>
                    {new Date(item.createdAt).toLocaleString()}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default GetAllResellerWallet;
